export const CONSTANTS_STRINGS = {
  PAGE_NOT_FOUND_TITLE: "Oops!",
  PAGE_NOT_FOUND_SUBTITLE: "Hmmm, não encontramos os dados da sua proposta.",
  PAGE_NOT_FOUND_DESCRIPTION: "Parece que essa proposta expirou ou não existe.",
  PAGE_NOT_FOUND_FOOTER:
    "Em caso de dúvidas, entre em contato com o seu corretor.",
  EXPIRED_LINK_TITLE: "Oops!",
  EXPIRED_LINK_SUBTITLE: "Esse link de pagamento não está mais disponível.",
  EXPIRED_LINK_DESCRIPTION:
    "Parece que esse pedido já foi pago, expirou ou não existe.",
  EXPIRED_LINK_FOOTER:
    "Em caso de dúvidas, entre em contato com o seu corretor.",
  SUMMARY: "Resumo",
  PRODUCT_NAME: "Nome do Produto Contratado",
  SUMMARY_RESPONSIBLE_FINANCIAL_DOCUMENT_TITLE:
    "CPF/CNPJ do Responsável Financeiro",
  SUMMARY_RESPONSIBLE_FINANCIAL_NAME_TITLE: "Nome do Responsável Financeiro",
  SUMMARY_BROKER_NAME_TITLE: "Nome do Corretora",
  SUMMARY_INSURANCE_TYPE_TITLE: "Tipo de Seguro",
  SUMMARY_INSURANCE_ITEMS_TITLE: "Item segurado",
  SUMMARY_INSURANCE_ITEMS_PLURAL_TITLE: "Itens segurados",
  ORDER_PAYMENT_TITLE: "Pagamento",
  ORDER_SELECT_PAYMENT_METHOD_TITLE: "Selecione um método de pagamento",
  PAYMENT_METHOD_CREDIT_CARD: "Cartão de Crédito",
  PAYMENT_METHOD_PIX: "Pix",
  PAYMENT_METHOD_BANK_SLIP: "Boleto",
  PAYMENT_METHOD_OPEN_FINANCE: "Pix Open Finance",
  PAYMENT_METHOD_DIRECT_DEBIT: "Débito",
  PAYMENT_METHOD_BOLEPIX: "Boleto",
  EMPTY: "",
  CREDIT_CARD_TITLE: "Cartão de Crédito",
  CREDIT_CARD_NUMBER: "Número do Cartão",
  CREDIT_CARD_HOLDER: "Nome Completo",
  CREDIT_CARD_HOLDER_SUBLABEL: "Digite o mesmo nome impresso no cartão",
  CREDIT_CARD_EXPIRATION_DATE: "Data de Vencimento",
  CREDIT_CARD_SECURITY_CODE: "Código de Segurança",
  CREDIT_CARD_DOCUMENT: "CPF/CNPJ do Titular",
  CREDIT_CARD_DATE_OF_BIRTH: "Data de Nascimento",
  CREDIT_CARD_INSTALLMENTS: "Número de Parcelas",
  INSTALLMENT_VALUE_LABEL: "Valor da parcela",
  CREDIT_CARD_MAKE_PAYMENT: "Realizar Pagamento",
  CREDIT_CARD_BACK: "Voltar",
  CREDIT_CARD_NUMBER_PLACEHOLDER: "0000 0000 0000 0000",
  CREDIT_CARD_FULL_NAME_LABEL: "Nome do Titular",
  CREDIT_CARD_FULL_NAME_PLACEHOLDER: "Nome do Titular",
  CREDIT_CARD_EXPIRATION_DATE_PLACEHOLDER: "MM/AAAA",
  CREDIT_CARD_SECURITY_CODE_PLACEHOLDER: "CVV",
  CREDIT_CARD_DOCUMENT_LABEL: "CPF/CNPJ do Titular",
  CREDIT_CARD_DOCUMENT_PLACEHOLDER: "CPF/CNPJ do Titular",
  CREDIT_CARD_DATE_OF_BIRTH_LABEL: "Data de Nascimento",
  CREDIT_CARD_DATE_OF_BIRTH_PLACEHOLDER: "DD/MM/AAAA",
  CREDIT_CARD_INSTALLMENTS_LABEL: "Número de Parcelas",
  CREDIT_CARD_INSTALLMENTS_PLACEHOLDER: "Selecione o número de parcelas",
  INSTALLMENT_VALUE_PLACEHOLDER: "Selecione o valor da parcela",
  CREDIT_CARD_BILLING_DAY_LABEL: "Data de fechamento da fatura *",
  BRAND_VISA: "VISA",
  BRAND_MASTERCARD: "MASTERCARD",
  BRAND_AMEX: "AMEX",
  BRAND_DISCOVER: "DISCOVER",
  BRAND_DINERS: "DINERS",
  ERROR_PAYMENT_METHOD: "Erro ao selecionar o método de pagamento",
  REQUIRED: "Campo obrigatório",
  INVALID_CARD_NUMBER: "Número do cartão inválido",
  INVALID_HOLDER: "Nome do titular inválido",
  INVALID_DOCUMENT: "CPF/CNPJ do titular inválido",
  INVALID_DATE_OF_BIRTH: "Data de nascimento inválida",
  INVALID_DATE_OF_BIRTH_CPF: "Você deve ter pelo menos 18 anos",
  INVALID_DATE_OF_BIRTH_CNPJ: "Data de fundação inválida",
  INVALID_SECURITY_CODE: "Código de segurança inválido",
  INVALID_EXPIRATION_DATE: "Data de expiração inválida",
  CONTINUE: "Continuar",
  SELECT_PAYMENT_METHOD_LEGEND: "Selecione um método de pagamento",
  CREDIT_CARD_WARNING_TITLE: "O pagamento não foi realizado.",
  CREDIT_CARD_WARNING_DESCRIPTION:
    "Por favor, verifique os dados do cartão e tente novamente.",
  CREDIT_CARD_PAYMENT_SUCESS_TITLE: "Etapa concluída.",
  CREDIT_CARD_PAYMENT_SUCESS_CARD_TITLE: "O pagamento está em processamento.",
  CREDIT_CARD_PAYMENT_SUCESS_CARD_MESSAGE:
    "Você receberá uma mensagem de confirmação do pagamento. Em caso de erro, entre em contato com a operadora do cartão.",
  CREDIT_CARD_PAYMENT_SCHEDULED_TITLE: "Pagamento agendado com sucesso!",
  CREDIT_CARD_PAYMENT_SCHEDULED_CARD_TITLE: "Seu pagamento foi agendado.",
  CREDIT_CARD_PAYMENT_SCHEDULED_CARD_MESSAGE:
    "O pagamento será processado na data agendada. Você receberá uma confirmação por e-mail quando o pagamento for efetivado.",
  CREDIT_CARD_PAYMENT_ERROR_TITLE: "Pagamento não realizado",
  CREDIT_CARD_PAYMENT_ERROR_SUBTITLE: "Por favor, tente novamente",
  CREDIT_CARD_PAYMENT_ERROR_CARD_TITLE: "Pagamento não realizado",
  CREDIT_CARD_PAYMENT_ERROR_CARD_MESSAGE:
    "Por favor, tente novamente. Se o erro persistir, entre em contato com a operadora do cartão.",
  CREDIT_LIMIT_OPTION_PLACEHOLDER: "Selecione uma opção",
  CREDIT_LIMIT_OPTION_LABEL: "Selecione a melhor opção: *",
  RECOMMENDED: "RECOMENDADO",
  PIX_PAGE_TITLE: "Pix",
  PIX_PAGE_DESCRIPTION: "Pagamento com Pix",
  PIX_PAGE_QRCODE_INFO_MESSAGE_PIX_MOBILE: "Use o código no app do seu banco:",
  PIX_PAGE_QRCODE_INFO_MESSAGE_PIX_DESKTOP:
    "Escaneie o QR Code ou use o código no app do seu banco:",
  PIX_PAGE_COPY_CODE_TEXT: "Copiar chave Pix",
  COPIED_TO_CLIPBOARD: "Código copiado para a área de transferência",
  PIX_PAGE_INFO_CARD_TITLE: "PIX gerado com sucesso!",
  PIX_PAGE_INFO_CARD_DESCRIPTION:
    "Pague através do QRCode ou copie o código link\nEfetue o pagamento em até 5 dias corridos.",
  PIX_PAYMENT_ERROR_TITLE: "Pagamento não realizado",
  PIX_PAYMENT_ERROR_CARD_TITLE: "Pagamento não realizado",
  PIX_PAYMENT_ERROR_CARD_MESSAGE:
    "Por favor, tente novamente. Se o erro persistir, entre em contato com a empresa.",
  PIX_PAYMENT_SUCCESS_TITLE: "Etapa concluída.",
  PIX_PAYMENT_SUCCESS_CARD_TITLE: "O pagamento está em processamento.",
  PIX_PAYMENT_SUCCESS_CARD_MESSAGE:
    "Você receberá uma mensagem de confirmação do pagamento. Em caso de erro, entre em contato com seu banco.",
  PIX_PRE_AUTHORIZATION_ERROR_TITLE: "Pix não gerado",
  PIX_PRE_AUTHORIZATION_ERROR_CARD_TITLE: "Não foi possível gerar o pix",
  PIX_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE:
    "Não foi possível gerar o pix agora. Por favor, tente novamente ou escolha outra forma de pagamento.",
  PIX_LOADING_ERROR_TITLE: "Erro ao carregar PIX",
  PIX_LOADING_ERROR_MESSAGE:
    "Não foi possível carregar as opções de pagamento. Por favor, tente novamente.",
  PIX_INSTALLMENTS_SELECTION_TITLE: "Selecione o número de parcelas:",

  // Cartão de Crédito - Pre Authorization Error
  CREDIT_CARD_PRE_AUTHORIZATION_ERROR_TITLE: "Pagamento não autorizado",
  CREDIT_CARD_PRE_AUTHORIZATION_ERROR_CARD_TITLE:
    "Pagamento recusado pela operadora",
  CREDIT_CARD_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE:
    "Verifique os dados do cartão ou entre em contato com a operadora do seu cartão.",

  // Boleto - Pre Authorization Error
  BANK_SLIP_PRE_AUTHORIZATION_ERROR_TITLE: "Boleto não gerado",
  BANK_SLIP_PRE_AUTHORIZATION_ERROR_CARD_TITLE:
    "Não foi possível gerar o boleto",
  BANK_SLIP_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE:
    "Não foi possível gerar o boleto agora. Por favor, tente novamente ou escolha outra forma de pagamento.",

  // Débito Direto - Pre Authorization Error
  DIRECT_DEBIT_PRE_AUTHORIZATION_ERROR_TITLE: "Pagamento não autorizado",
  DIRECT_DEBIT_PRE_AUTHORIZATION_ERROR_CARD_TITLE:
    "Débito não autorizado pelo banco",
  DIRECT_DEBIT_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE:
    "Verifique os dados bancários informados ou entre em contato com seu banco.",

  // Boleto - Pre Authorization Error
  BOLEPIX_PRE_AUTHORIZATION_ERROR_TITLE: "Boleto não gerado",
  BOLEPIX_PRE_AUTHORIZATION_ERROR_CARD_TITLE: "Não foi possível gerar o Boleto",
  BOLEPIX_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE:
    "Não foi possível gerar o boleto agora. Por favor, tente novamente ou escolha outra forma de pagamento.",

  // Open Finance - Pre Authorization Error
  OPEN_FINANCE_PRE_AUTHORIZATION_ERROR_TITLE: "Pagamento não autorizado",
  OPEN_FINANCE_PRE_AUTHORIZATION_ERROR_CARD_TITLE:
    "Autorização bancária negada",
  OPEN_FINANCE_PRE_AUTHORIZATION_ERROR_CARD_MESSAGE:
    "A instituição financeira não autorizou o pagamento. Tente novamente ou escolha outro método.",

  BANK_SLIP_PAGE_TITLE: "Boleto",
  BANK_SLIP_YOU_CAN_NOW_MAKE_THE_PAYMENT: "Você já pode realizar o pagamento.",
  BANK_SLIP_ENTER_YOUR_CPF_CNPJ:
    "Para abrir o boleto, digite os 4 primeiros dígitos do seu CPF/CNPJ.",
  BANK_SLIP_INFO_TEXT:
    "Em caso de parcelamento, os demais boletos serão enviados mensalmente por e-mail e WhatsApp.",
  BANK_SLIP_PAGE_BANK_SLIP_DATA_TITLE: "Aqui está seu boleto:",
  BANK_SLIP_DUE_DAY_LABEL: "Data de Vencimento",
  BANK_SLIP_DUE_DAY_PLACEHOLDER: "Escolha um dia",
  BANK_SLIP_DUE_DAY_DESCRIPTION:
    "Selecione o dia que será a data de vencimento das próximas parcelas.",
  BANK_SLIP_PAGE_QRCODE_INFO_MESSAGE_MOBILE: `Pague seu boleto via PIX!
  É só copiar ou compartilhar a chave pix abaixo:`,
  BANK_SLIP_PAGE_QRCODE_INFO_MESSAGE_DESKTOP:
    "Pague seu boleto via PIX!\n Aponte a câmera do seu celular para o QR Code.",
  BANK_SLIP_PAGE_COPY_CODE_TEXT: "Copiar Código",
  BANK_SLIP_PAYMENT_SUCESS_TITLE: "Tudo certo!",
  BANK_SLIP_PAYMENT_SUCESS_CARD_TITLE: "Processo finalizado!",
  BANK_SLIP_PAYMENT_SUCESS_CARD_MESSAGE:
    "O processamento do pagamento pode levar até 3 dias úteis. Você receberá a confirmação do pagamento por e-mail.",
  BANK_SLIP_PAYMENT_ERROR_TITLE: "Pagamento não realizado",
  BANK_SLIP_PAYMENT_ERROR_CARD_TITLE: "Pagamento não realizado",
  BANK_SLIP_PAYMENT_ERROR_CARD_MESSAGE:
    "Por favor, tente novamente. Se o erro persistir, entre em contato com seu corretor.",
  BANK_SLIP_INSTALLMENTS_SELECTION_TITLE: "Selecione o número de parcelas:",
  BANK_SLIP_AMOUNT_LABEL: "Boleto de ",
  PAYMENT_CONFIRMED_TITLE: "Etapa concluída.",
  PAYMENT_CONFIRMED_CARD_TITLE: "O pagamento está em processamento.",
  PAYMENT_CONFIRMED_CARD_MESSAGE:
    "Você receberá uma mensagem de confirmação do pagamento. Em caso de erro, entre em contato com seu banco.",
  PRE_AUTHORIZATION_ERROR_TITLE: "Pagamento não autorizado",
  PRE_AUTHORIZATION_ERROR_CARD_TITLE: "Pagamento não autorizado",
  PRE_AUTHORIZATION_ERROR_CARD_MESSAGE:
    "Por favor, tente novamente. Se o erro persistir, entre em contato com a sua corretora.",
  DIRECT_DEBIT_PAGE_TITLE: "Débito",
  DIRECT_DEBIT_PAGE_INFO_CARD_TITLE:
    "Selecione seu banco e insira os dados referêntes à agência e conta bancária:",
  DIRECT_DEBIT_CONFIRMED_BUTTON_TEXT: "Confirmar",
  BANK_LIST_PRESENTATION_ERROR_MESSAGE: "Erro ao carregar lista de bancos",
  DIRECT_DEBIT_AUTHORIZATION_SUBTITLE:
    "Revise suas informações antes de autorizar o pagamento",
  DIRECT_DEBIT_AUTHORIZATION_BUTTON_TEXT: "Autorizar pagamento",
  DIRECT_DEBIT_AUTHORIZATION_INFO_CARD_DESCRIPTION:
    "Para concluir a ativação do seu seguro autorize o débito automático no aplicado bancário no próximo dia útil.",
  DIRECT_DEBIT_AUTHORIZATION_INFO_CARD_IMPORTANT_LABEL: "Importante:",
  DIRECT_DEBIT_AUTHORIZATION_INFO_CARD_IMPORTANT_MESSAGE:
    "a solicitação de autorização ficará disponível no próximo dia útil para checkouts preenchidos até as 18h. Quando o preenchimento ocorrer após as 18h, a solicitação ficará disponível no segundo dia útil seguinte.",
  DIRECT_DEBIT_BILLING_DAY_LABEL: "Data de vencimento da segunda parcela",
  DIRECT_DEBIT_BILLING_DAY_LIFE_LABEL: "Data do Próximo Vencimento",
  DIRECT_DEBIT_BILLING_DAY_PLACEHOLDER: "Dia",
  DIRECT_DEBIT_FINANCIAL_INSTITUTION: "Instituição Financeira",
  DIRECT_DEBIT_AGENCY: "Agência",
  DIRECT_DEBIT_ACCOUNT: "Conta",
  DIRECT_DEBIT_DIGIT: "Dígito",
  EDIT_ACCOUNT_BUTTON_ARIA_LABEL: "Editar dados bancários",
  DIRECT_DEBIT_PAYMENT_SUCCESS_TITLE: "Etapa concluída.",
  DIRECT_DEBIT_PAYMENT_IN_PROGRESS: "Pagamento em andamento.",
  DIRECT_DEBIT_PRE_AUTHORIZATION_MESSAGE:
    "Acesse o aplicativo do seu banco para autorizar o débito. <strong>Se o checkout for preenchido até as 18h, a solicitação estará disponível no próximo dia útil. Caso o preenchimento ocorra após esse horário, a solicitação estará disponível no segundo dia útil seguinte.</strong>",
  DIRECT_DEBIT_PAYMENT_ERROR_TITLE: "Pagamento não realizado",
  DIRECT_DEBIT_PAYMENT_ERROR_CARD_TITLE: "Pagamento não realizado",
  DIRECT_DEBIT_PAYMENT_ERROR_CARD_MESSAGE:
    "Não foi possível processar o pagamento com débito. Por favor, verifique se há saldo suficiente em sua conta e tente novamente.",
  PRE_AUTHORIZATION_WAITING_TITLE: "Aguardando autorização",
  PRE_AUTHORIZATION_WAITING_SUBTITLE:
    "Aguarde a autorização do pagamento antes de finalizar a compra.",
  PRE_AUTHORIZATION_WAITING_MESSAGE:
    "O pagamento será processado em até 3 dias úteis. Você receberá a confirmação do pagamento por e-mail.",
  PRE_AUTHORIZED_BY_GATEWAY_TITLE: "Pagamento pré-autorizado",
  PRE_AUTHORIZED_BY_GATEWAY_CARD_TITLE: "Aguardando confirmação do Gateway",
  PRE_AUTHORIZED_BY_GATEWAY_CARD_MESSAGE:
    "Seu pagamento foi pré-autorizado pelo Gateway, mas ainda não foi confirmado. Verifique no seu e-mail, aplicativo do banco, agência ou com seu corretor se o pagamento foi aprovado.",
  BOLEPIX_PAYMENT_TITLE: "Boleto",
  BOLEPIX_PAYMENT_CARD_TITLE: "Processo finalizado!",
  BOLEPIX_PAYMENT_CARD_MESSAGE:
    "O processamento do pagamento pode levar até 3 dias úteis. Você receberá a confirmação do pagamento por e-mail.",
  BOLEPIX_PAYMENT_ERROR_TITLE: "Pagamento não realizado",
  BOLEPIX_PAYMENT_ERROR_CARD_TITLE: "Pagamento não realizado",
  BOLEPIX_PAYMENT_ERROR_CARD_MESSAGE:
    "Não foi possível gerar o boleto bancário. Por favor, tente novamente ou escolha outra forma de pagamento.",
  BANKSLIP_PAYMENT_ERROR_MESSAGE:
    "Não foi possível gerar o boleto bancário. Por favor, tente novamente ou escolha outra forma de pagamento.",
  SHARE_FAILED: "Falha ao compartilhar",
  SHARE_NOT_SUPPORTED: "Compartilhamento não suportado, código copiado",
  NO_QR_CODE_TO_DISPLAY: "Não há QR Code para ser exibido",
  BANK_LIST_PRESENTATION_TITLE: "Conveniados",
  NO_NAME_TITLE: "Sem nome",
  ERROR_PUBLIC_KEY_NOT_FOUND: "Chave pública não encontrada",
  SELECT_DAY_PLACEHOLDER: "Selecione o dia",
  CREDIT_CARD_TOOLTIP_TEXT:
    "Se a fatura do seu cartão fecha no dia 29, sugerimos selecionar a data 1 ou 2",
  CREDIT_LIMIT_TOOLTIP_TEXT:
    "Escolha como a sua transação impactará o limite do seu cartão. Selecione 'Sem tomar limite...' se não quiser usar o limite de crédito disponível. Selecione 'Tomar limite...' para utilizar parte do seu limite.",
  PAYMENT_SUCCESS_MESSAGE:
    "Agora é só aguardar a emissão de sua apólice ou do retorno.",
  INSTALLMENTS_LOADING_EMPTY_ERROR_TITLE: "Nenhuma parcela disponível",
  INSTALLMENTS_LOADING_ERROR_TITLE: "Erro ao carregar parcelas",
  INSTALLMENTS_LOADING_ERROR_MESSAGE:
    "Não há opções de parcelamento disponíveis para esse pedido criado.",
  VERIFYING_PAYMENT_STATUS: "Verificando status do pagamento...",
  BACK_TO_PAYMENT_METHODS: "Voltar para os meios de pagamento",
  REVERSED_FAILED_TITLE: "Falha no cancelamento",
  REVERSED_FAILED_CARD_TITLE: "Não foi possível cancelar o pagamento",
  REVERSED_FAILED_CARD_MESSAGE:
    "Ocorreu um erro ao tentar cancelar o pagamento. Por favor, entre em contato com o suporte para mais informações.",
  LIFE_INSURANCE: "Seguro Vidas",
};
